<template>
	<div class="my-coupon">
		<nav-bar navBarTitle="我的优惠券"></nav-bar>
		<coupon-list></coupon-list>
	</div>
</template>

<script>
	import couponList from './components/couponList'

	export default {
		name: 'coupon',
		components: {
			couponList
		}
	};
</script>

<style lang="less" scoped>
	.my-coupon {
		/deep/ .van-tab {
			font-size: 16px;
			color: @subBlack;
		}
		/deep/  .van-tabs--line .van-tabs__wrap {
			height: 50px;
			background:rgba(255,255,255,1);
			box-shadow:0px 0px 20px 0px rgba(0,0,0,0.05);
		}
		/deep/ .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
			border-width: 0px 0;
		}
		/deep/ .van-tabs__line {
			width: 20px!important;
			position: absolute;
			top: 43px;
			left: 0;
			z-index: 1;
			height: 2px;
			background-color: @baseBlue;
			border-radius: 3px;
		}
		/deep/ .van-tab--active {
			color: @darkBlack;
			font-weight: 400;
		}
		/deep/ .van-tabs__content {
			padding: 0 16px;
		}
	}
</style>
